<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">计划单号</span>
        <el-input placeholder="请输入关键词" v-model="conditions.pno" clearable>
        </el-input>
        <span class="fonints">车牌号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
        >
        </el-input>
        <span class="fonints">货主名称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.customname"
          clearable
        >
        </el-input>
        <span class="fonints">rfid卡号</span>
        <el-input
          style="width: 230px"
          placeholder="请读取或填写rfid卡号"
          v-model="conditions.rfid"
          clearable
          @clear="conditions.rfid = ''"
        >
        </el-input>
      </div>
      <div class="componentSty_content_title">
        <span class="fonints">代理名称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.agentname"
          clearable
        >
        </el-input>
        <span class="fonints">货场名称</span>
        <div class="select_box">
          <m-select :list="selectastrict" v-model="selectinfo"></m-select>
        </div>
        <button class="buttons" @click="selectlist">查询</button>
       
      </div>
      <div class="componentSty_content_title">
        <button
          class="buttons"
          style="background: #13d168"
          @click="approved(true)"
        >
          审核通过
        </button>
        <button
          class="buttons"
          style="background: #ff5926"
          @click="approved(false)"
        >
          审核不通过
        </button>
      </div>
      <div class="componentSty_content_table" style="top: 135px;border:none">
        <el-table
          :data="arrlist.data"
          style="width: 100%; "
          @sort-change="sortchange"
          height="80%"
          border
          @selection-change="selChange"
        >
          <el-table-column show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip type="selection"> </el-table-column>
          <el-table-column show-overflow-tooltip
            prop="pno"
            label="计划单号"
            sortable="custom"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="storename" label="货场名称"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="customname" label="货主名称">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="agentname" label="代理名称"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="custmername" label="流向"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="fleetname" label="代理名称"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号"> </el-table-column>
          <el-table-column show-overflow-tooltip label="计划吨数">
            <template v-slot="res">
              <span>{{ res.row.plantons  }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作">
            <template v-slot="res">
              <span
                @click="iteminfofun(res.row)"
                class="iconfont icon-chakan"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.data && arrlist.data.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.count"
            :current-page="conditions.page"
            @current-change="getarrlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { mapMutations, mapState } from "vuex";
import mSelect from "@/components/mSelect";
import { antiShake, readRFIDcard_new } from "@/plugins/other.js";
export default {
  data() {
    return {
      connState: 1,
      isReading: false, //读卡状态 。
      selectastrict: [],
      listitem: [{ name: "审核管理" }, { name: "线上审核" }],
      selectinfo: "全部",
      conditions: {
        rfid: "",
        page: 1,
        limit: 20,
        storename: "",
      },
      arrlist: [],
      platelist: [],
      ids: [],
      idcard: "",
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  watch: {
    idcard(nval) {
      if (nval == "读卡器打开成功!" || nval === "读卡器连接异常!") return "";
      this.conditions.rfid = nval;
      this.getarrlist();
    },
  },
  created() {
    // this.conditionsList[this.$route.path] ||
    //   this.createConditions({ key: this.$route.path });
    // this.conditions = this.conditionsList[this.$route.path] || {
    //   page: 1,
    //   limit: 20,
    // };
    // console.log(this.conditions)
    this.getarrlist();
    this.getselectastrict();
  },
  components: {
    mTitle,
    mSelect,
  },
  // beforeDestroy() {
  //   window.ws && window.ws.close();
  //   window.ws = null;
  // },
  methods: {
    ...mapMutations(["createConditions", "addnavigationMsg"]),
    async getarrlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      this.selectinfo == "全部"
        ? (this.conditions.storename = null)
        : (this.conditions.storename = this.selectinfo);
      for (var i in this.selectitem) {
        if (!this.selectitem[i]) this.selectitem[i] = null;
      }
      const { data } = await this.$http(
        "api1",
        "/driver/dispatchtruck/vehicleDispatchingAuditPlan",
        "post",
        this.conditions
      );
      if (!data.data) return;
      this.arrlist = data;
    },
    async getselectastrict() {
      const { data } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "货场",
      });
      if (data.code != 0) return;
      this.selectastrict = ["全部"];
      data.data.forEach((item) => {
        this.selectastrict.push(item.val);
      });
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getarrlist();
      });
    },
    
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getarrlist();
    },
    selChange(event) {
      this.ids = [];
      this.platelist = [];
      event.forEach((item) => {
        this.ids.push(item.id);
        this.platelist.push(item.plate);
      });
    },
    approved(info) {
      if (!this.ids.length) return;
      var path = "",
        title = "",
        successifo = "";
      if (info) {
        path = "/driver/dispatchtruck/approveSendSomeonePlan";
        title = "是否通过";
        successifo = "审核已通过";
      } else {
        title = "是否不通过";
        path = "/driver/dispatchtruck/FailedAuditSendSomeonePlan";
        successifo = "操作成功";
      }
      this.$messageBox
        .confirm(`${title}?`, `${this.platelist + "" || "提示"}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http("api1", path, "post", {
            ids: this.ids,
          });
          if (data.code == 500) return this.$message.error(data.msg);
          this.$message.success(successifo);

          this.conditions.pno = null;
          this.conditions.plate = null;
          this.conditions.customname = null;
          this.conditions.agentname = null;
          this.selectinfo = "全部";
          this.conditions.rfid = this.idcard = null;

          this.getarrlist();
        })
        .catch((err) => err);
    },
    iteminfofun(obj) {
      this.addnavigationMsg([{}, { path: "/audit/auditcar" }]);
      this.$router.push("/audit/infomsg/" + obj.id);
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
